import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.config}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}` +
  '/configuration/acceptedLanguages';

export interface SetSellerConfigurationAcceptedLanguagesCommandArgs {
  sellerId?: string | null;
  acceptedLanguages?: string[] | null;
}

export const setSellerConfigurationAcceptedLanguagesRequest = ({
  sellerId,
  acceptedLanguages,
}: SetSellerConfigurationAcceptedLanguagesCommandArgs): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId ?? ''),
  config: {
    method: SUPPORTED_METHODS.POST,
    json: { acceptedLanguages },
  },
});

export const setSellerConfigurationAcceptedLanguagesCommand = async (
  payload: SetSellerConfigurationAcceptedLanguagesCommandArgs,
): Promise<BaseBackResponse | BackResponseFailure> => {
  try {
    return await executeQuery<BaseBackResponse>(
      setSellerConfigurationAcceptedLanguagesRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
